import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import MediaGrid from "../components/tables/MediaGrid";

export default function MediaPage() {
    return (
        <>
            <PageMeta
                title="Media Library | Shoplattice Admin Dashboard"
                description="Manage Uploaded Files and Media"
            />
            <PageBreadcrumb pageTitle="Media Library" />
            <div className="space-y-6">
                <MediaGrid />
            </div>
        </>
    );
}
